/* eslint-disable @typescript-eslint/no-explicit-any */
import { GetCartSuccessResponse } from '@services/useGetCart';
import { ShoppingCartTotalData } from '@types';
import { useMemo } from 'react';

const useCartSummary = (cartData: GetCartSuccessResponse['data'] | null | undefined) => {
    const formattedCart = useMemo<() => ShoppingCartTotalData>(() => {
        if (!cartData) {
            return () => ({
                productsValue: 0,
                promotion: {
                    discount: 0,
                    eligibleItems: [],
                },
                subtotal: 0,
                shipping: null,
                total: 0,
                points: 0,
                nProducts: 0,
                products: [],
            });
        }

        return () => ({
            productsValue: cartData.productsValue || 0,
            promotion: {
                discount: cartData.promotion?.discount || 0,
                eligibleItems: cartData.promotion?.eligibleItems || [],
            },
            subtotal: cartData.subtotal || 0,
            shipping: cartData.shipping === undefined ? null : cartData.shipping,
            total: cartData.total || 0,
            points: cartData.points || 0,
            nProducts: cartData.nProducts || 0,
            products: (cartData.productsByMerchant || []).flatMap((merchant: any) =>
                (merchant.cartItems || []).map((cartItem: any) => ({
                    name: cartItem.product.name || '',
                    image: cartItem.product.image || '',
                    price: cartItem.price || 0,
                    quantity: cartItem.quantity || 0,
                }))
            ),
        });
    }, [cartData]);

    const getProductsByMerchant = useMemo(() => {
        return () => {
            if (!cartData) {
                return [];
            }

            return (cartData.productsByMerchant || []).map((merchant: any) => ({
                merchant: merchant.merchant || '',
                products: (merchant.cartItems || []).map((cartItem: any) => ({
                    uuid: cartItem.uuid || '',
                    name: cartItem.product.name || '',
                    image: cartItem.product.image || '',
                    price: cartItem.price || 0,
                    quantity: cartItem.quantity || 0,
                    availability: cartItem.availability || '',
                })),
            }));
        };
    }, [cartData]);

    return {
        formattedCart,
        getProductsByMerchant,
    };
};

export default useCartSummary;
